






import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";

// Components
import AffiliatesProvider from "@/components/app/global/affiliate/affiliatesProvider.vue";
import AffiliatesTable from "@/components/app/global/affiliate/affiliatesTable.vue";
import BrandPaymentMethodsList from "@/components/app/global/payments/brandPaymentMethodsList.vue";
import ClientSearch from "@/components/app/global/client/clientSearch.vue";
import LegacyInvoicesProvider from "@/components/app/global/legacyInvoices/legacyInvoicesProvider.vue";
import LegacyInvoicesTable from "@/components/app/global/legacyInvoices/legacyInvoicesTable.vue";
import ProductsSearch from "@/components/app/admin/catalogue/products/productSearchTable.vue";
import ProductsTable from "@/components/app/global/contractProducts/productsTable.vue";
import TicketsTable from "@/components/app/global/tickets/ticketsTable.vue";
import UserSearch from "@/components/app/global/user/userSearchTable.vue";

// Types
import { IImport, IImportStep } from "@/models/imports";
import { ImportStatusCodes, ImportStepCodes } from "@/data/enums/imports";

@Component
export default class StagedRecordsModal extends Vue {
  // Props

  @Prop({ required: true })
  public step!: IImportStep;

  @Prop({ required: true })
  public importId!: IImport["id"];

  @Prop({ required: true })
  public importBrandId!: IImport["brand_id"];

  // Computed

  public get title() {
    return this.$t("_sentence.imports.step_staged_records", {
      stepName: this.step.name
    });
  }

  public get component() {
    const manualFilters = {
      with_staged_imports: 1,
      ...(this.step.status.code !== ImportStatusCodes.COMPLETE
        ? { "filter[staged_import]": 1 }
        : {}),
      "filter[import_id]": this.importId
    };

    switch (this.step.code) {
      case ImportStepCodes.PRODUCTS:
        return {
          render: (h: CreateElement) =>
            h(ProductsSearch, {
              props: {
                brandId: this.importBrandId,
                ignoreHistory: true,
                limit: 5,
                manualFilters
              }
            })
        };
      case ImportStepCodes.CLIENTS:
        return {
          render: (h: CreateElement) =>
            h(ClientSearch, {
              props: {
                brandId: this.importBrandId,
                showGuestsToggle: false,
                manualFilters
              }
            })
        };
      case ImportStepCodes.AFFILIATE_ACCOUNTS:
        return {
          render: (h: CreateElement) =>
            h(
              AffiliatesProvider,
              {
                props: {
                  dataScope: "$staged_affiliates",
                  ignoreHistory: true,
                  manualFilters,
                  limit: 5
                }
              },
              [h(AffiliatesTable)]
            )
        };
      case ImportStepCodes.USERS:
        return {
          render: (h: CreateElement) =>
            h(UserSearch, {
              props: {
                dataScope: "$staged_user_search",
                showTableHead: false,
                manualFilters
              }
            })
        };
      case ImportStepCodes.CLIENT_PAYMENT_DETAILS:
        return {
          render: (h: CreateElement) =>
            h(BrandPaymentMethodsList, {
              props: {
                brandId: this.importBrandId,
                dataScope: "$staged_payment_methods",
                showTableHead: false,
                manualFilters
              }
            })
        };
      case ImportStepCodes.CONTRACTS:
        return {
          render: (h: CreateElement) =>
            h(ProductsTable, {
              props: {
                dataScope: "$staged_contracts",
                showTableHead: false,
                id: "CPT1",
                manualFilters,
                ignoreHistory: true,
                limit: 5,
                showWhenPurchased: false,
                isStaged: true
              }
            })
        };
      case ImportStepCodes.INVOICES:
        return {
          render: (h: CreateElement) =>
            h(
              LegacyInvoicesProvider,
              {
                props: {
                  dataScope: "$staged_legacy_invoices",
                  ignoreHistory: true,
                  limit: 5,
                  manualFilters
                }
              },
              [h(LegacyInvoicesTable)]
            )
        };
      case ImportStepCodes.TICKETS:
        return {
          render: (h: CreateElement) =>
            h(TicketsTable, {
              props: {
                dataScope: "$staged_tickets",
                setDefaultStatusFilter: false,
                manualFilters,
                ignoreHistory: true,
                limit: 5
              }
            })
        };
      default:
        return {};
    }
  }
}
